export default ({
  onClick,
  children,
  error,
  loading,
  id,
  type = 'button',
  width = 'auto',
  maxWidth,
  height,
  minWidth,
  disabled = false,
  className,
  secondary = false,
  fontSize,
  marginTop,
  marginBottom,
  marginLeft,
  marginRight,
  color,
  noOutline
}) => {
  return (
    <div>
      <button
        id={id}
        type={type}
        className={`button ${className} ${
          secondary ? 'is-secondary' : 'is-primary'
        } is-uppercase ${noOutline && 'no-outline'}`}
        onClick={onClick}
        disabled={loading || disabled || (error && error.type == 'format')}
      >
        {loading && (
          <div>
            <i className="fa fa-spinner fa-spin" />
            &nbsp;&nbsp;&nbsp;
          </div>
        )}
        {children}
      </button>
      <style jsx>{`
        .button {
          box-shadow: 0 2.5px 2.5px 0 #cecece;
          border-radius: 4px;
          font-size: ${fontSize ? fontSize : '16px'};
          padding-bottom: 5px;
          height: ${height ? height : '50px'};
          padding-left: 2em;
          padding-right: 2em;
          width: ${width};
          max-width: ${maxWidth};
          height: ${height ? height : '50px'};
          min-width: ${minWidth ? minWidth : '0px'};
          margin-top: ${marginTop ? marginTop : '48px'};
          margin-bottom: ${marginBottom};
          margin-left: ${marginLeft};
          margin-right: ${marginRight};
          background-color: ${color};
        }

        .button.no-outline {
          box-shadow: none;
          border-width: 0px;
        }

        @keyframes fa-spin {
          0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
          }
          100% {
            -webkit-transform: rotate(359deg);
            transform: rotate(359deg);
          }
        }
        .fa-spin {
          -webkit-animation: fa-spin 0.5s infinite linear !important;
          animation: fa-spin 0.5s infinite linear !important;
        }

        @media all and (max-width: 768px) {
          .button {
            height: ${height ? height : '42px'};
            margin-top: ${marginTop ? marginTop : '22px'};
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
};
